import {MatchStatus} from './MatchStatus/MatchStatus';

type ActivityType = 'match_event' | 'match_comment';
interface MatchActivityBase<Type extends ActivityType> {
  activityAt: string;
  activityType: Type;
}
export interface MatchEventContent {
  eventType: 'create' | 'status_change';
  fromStatus: MatchStatus;
  toStatus: MatchStatus | null;
  authorName: string;
}

export interface MatchCommentContent {
  resourceId: string;
  authorName: string;
  authorId: string;
  content: string;
}

export interface MatchEvent extends MatchActivityBase<'match_event'> {
  activityContent: MatchEventContent;
}

export interface MatchComment extends MatchActivityBase<'match_comment'> {
  activityContent: MatchCommentContent;
}

export type MatchActivity = MatchEvent | MatchComment;

export interface MatchActivityResponse {
  matchActivity: MatchActivity[];
}

export const isMatchEvent = (activity: MatchActivity): activity is MatchEvent => {
  return activity.activityType === 'match_event';
};
